import { Component, EventEmitter, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

import { UsuarioPerfil } from "@shared/Entities/Usuario/usuario-perfil.entity";

@Component({
  selector: "app-select-profile-modal",
  templateUrl: "./select-profile-modal.component.html",
  styleUrls: ["./select-profile-modal.component.scss"],
})
export class SelectProfileModalComponent implements OnInit {
  public title: string = "";
  public text: string = "";
  public selectProfileBind: number = 0;
  public profileList: UsuarioPerfil[] = [];
  public perfilId: number;
  public showInstructions: boolean = false;
  public selectedProfile = new EventEmitter<number>();

  constructor(private bsModalRef: BsModalRef) {}

  public ngOnInit(): void {
    this.selectProfileBind = this.profileList.find((x) => x.perfilId === this.perfilId)?.perfilId;
  }

  public closeMe(): void {
    this.bsModalRef.hide();
  }

  public confirm(selectedValue: number): void {
    this.selectedProfile.emit(selectedValue);
  }
}
